import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { trackExperimentViewed } from '@mc/track-event'

import { CONTEXTUAL_BROWSE_EXP_FLAG } from '../constants'
import { CategoryPageBrowseText } from './CategoryPageBrowseText'
import { CMPageBrowseText } from './CMPageBrowseText'
import { useContextualBrowseEnabled } from '../hooks/useContextualBrowseEnabled'
import { SubcategoryPageBrowseText } from './SubcategoryPageBrowseText'

interface BrowseTextProps {
  children: React.ReactNode
}

export const BROWSE_TEXT_ID = 'browse-text'

export const BrowseText = ({ children }: BrowseTextProps) => {
  const { t } = useTranslation('@mc/next')
  const { enabled, isContextualBrowsePages } = useContextualBrowseEnabled()
  const router = useRouter()
  let component = children

  useEffect(() => {
    if (isContextualBrowsePages) {
      trackExperimentViewed(CONTEXTUAL_BROWSE_EXP_FLAG)
    }
  }, [isContextualBrowsePages])

  if (!enabled) return <div id={BROWSE_TEXT_ID}>{component}</div>

  if (router.pathname.includes(paths.category(''))) {
    component = <CategoryPageBrowseText defaultText={t('nav.cta.browse')} />
  }

  if (router.pathname.includes(paths.subcategoryPage(''))) {
    component = <SubcategoryPageBrowseText defaultText={t('nav.cta.browse')} />
  }

  if (
    router.pathname.includes(paths.classPage('')) ||
    router.pathname.includes(paths.seriesPage(''))
  ) {
    component = <CMPageBrowseText defaultText={t('nav.cta.browse')} />
  }

  return <div id={BROWSE_TEXT_ID}>{component}</div>
}
